import { render, staticRenderFns } from "./Add-currency.vue?vue&type=template&id=65388e74&"
import script from "./Add-currency.vue?vue&type=script&lang=js&"
export * from "./Add-currency.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports